module.exports = __webpack_public_path__ + "img/bj001-002.1ce7d90d.jpg";